module.exports = __webpack_public_path__ + "static/wallet_icon-aea9cd22236a9368eb9bfcbf2dd2cac7.svg";